import API_BASE_URL from "../utils/config";
import request from "../utils/request";


export async function fetchAllFaculties(data) {
  const url = `${API_BASE_URL}/faculties`;
  return request({
    url,
    method: "get",
    data,
  });
}
export async function httpCreateFaculty(data) {
    const url = `${API_BASE_URL}/faculties`;
    return request({
      url,
      method: "post",
      data,
    });
  }
export async function httpEditFaculty(data) {
    const { id, ...editData } = data;
    const url = `${API_BASE_URL}/faculties/${id}`;
    return request({
      url,
      method: "patch",
      data: editData,
    });
  }
  export async function httpDeleteFaculty(id) {
    const url = `${API_BASE_URL}/faculties/${id}`;
    return request({
      url,
      method: "delete",
    });
  }
  